export default {
    isLogged:false,//verifica si el usuario esta logueado
    secret:null,
    jwt:null,
    jwtImage:null, 
    error: false,
    errorMessage: '',
    msg:null,
    rol_id:null,
    id:null,
    vsap:null,

  }